import Button from '@/components/Button/newButtons';
import type { Business } from '@/modules/dashboard/dashboardTypes';
import { Map } from '@/resources/assets/images';
import type { BusinessInfoTabProps } from '../../BusinessInfoTab';

type AddressSessionProps = Pick<Business, 'address' | '_id'> &
	Pick<BusinessInfoTabProps, 'goToMap'>;

export const AddressSession = ({
	_id,
	address,
	goToMap
}: AddressSessionProps) => {
	return (
		<div className="flex w-full flex-col items-start gap-2">
			<strong className="flex items-center font-semibold text-dm-mid-grey">
				Address
			</strong>

			<section className="flex w-full items-center justify-between gap-2">
				<p className="font-semibold text-dm-white">
					{address?.address}
				</p>

				{goToMap && (
					<Button
						variant="secondary"
						card
						leftIcon={<Map />}
						onClick={() => goToMap(_id)}
					>
						Show on map
					</Button>
				)}
			</section>
		</div>
	);
};
